import { GeneralSetting } from '@apis/index'
import Button from '@components/button'
import Column from '@components/column'
import Fields from '@components/fields'
import Title from '@components/title'
import Wrapper from '@components/wrapper'
import { RootState } from '@store/index'
import { Helper } from '@utils/index'
import { Form, Formik } from 'formik'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

interface PageFormProps {
  title: string
  Key: string
}

const PageForm = ({ title, Key }: PageFormProps) => {
  const stateKey = Helper.toCamelCase(title)

  // ❗ Safe fallback for dynamic reducer state
  const Page = useSelector((state: RootState) => state?.[stateKey]?.data ?? {})

  const [initialValue, setInitialValue] = useState({ [Key]: '' })

  // 🔄 Fetch page data by key
  useEffect(() => {
    const fetchPage = async () => {
      try {
        await GeneralSetting.getByKey({
          id: Key,
          state: stateKey,
        })
      } catch (error) {
        console.error('Fetch Error:', error)
      }
    }
    fetchPage()
  }, [Key, stateKey])

  // 🔁 Update initial form value when Page updates
  useEffect(() => {
    if (typeof Page?.value === 'string') {
      setInitialValue({ [Key]: Page.value })
    }
  }, [Page, Key])

  // 📝 Form submit handler
  const handleSubmit = async (values: any) => {
    try {
      const payload = {
        key: Key,
        value: values[Key],
        title,
      }

      if (Page?.id) {
        await GeneralSetting.update({
          id: Page.id,
          data: payload,
          state: stateKey,
        })
      } else {
        await GeneralSetting.create({
          data: payload,
          state: stateKey,
        })
      }
    } catch (error) {
      console.error('Submit Error:', error)
    }
  }

  return (
    <Fragment>
      <Column>
        <Title textone={title} texttwo="" />
        <Wrapper>
          <Formik
            initialValues={initialValue}
            enableReinitialize
            onSubmit={handleSubmit}
          >
            <Form>
              <Column>
                <Fields.Editor name={Key} />
                <Button
                  type="submit"
                  title="Save"
                  width={16}
                  height={45}
                  justify="flex-end"
                />
              </Column>
            </Form>
          </Formik>
        </Wrapper>
      </Column>
    </Fragment>
  )
}

export default PageForm
